<template>
  <div class="customer-edit ">
    <div class="container-fluid">
      <div class="col-12 overflow-auto">
        <div
                v-show="breakOrder"
                class="row bg-dark p-4"
                style="text-align: center;margin: auto;float: right;"
        >
          <H2>{{ $t('customer.break') }}</H2>
        </div>
        <div
          v-show="!allowOrder"
          class="row bg-danger p-4"
          style="text-align: center;margin: auto;float: right;"
        >
          <H2>{{ $t('customer.unpaidInvoices') }}</H2>
        </div>
        <h5 class="text-muted mr-auto p-2 float-left">
          <strong> {{ $t('customer.index') }}</strong>
          <h2>{{ currentCustomer.cardCode }} -  {{ currentCustomer.company }}</h2>
        </h5>
        <div
          v-show="allowOrder"
          class="p-2 col-12"
        >
          <router-link
            class="btn btn-theme-add  btn-xs-block float-right"
            :to="{ name: 'product', params: { type: 'service' }}"
          >
            {{ $t('buttons.createOrder') }}
          </router-link>
        </div>
      </div>
      <hr>
      <div class="container-fluid">
        <ul class="nav nav-tabs nav-pills">
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{ active: isActive('account') }"
              href="#account"
              @click.prevent="setActive('account')"
            > {{ $t('buttons.account') }}</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{ active: isActive('addresses') }"
              href="#addresses"
              @click.prevent="setActive('addresses')"
            >{{ $t('buttons.addresses') }}</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{ active: isActive('invoices') }"
              href="#invoices"
              @click.prevent="setActive('invoices')"
              @click="getInvoiceReport()"
            >{{ $t('buttons.invoices') }}</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{ active: isActive('orders') }"
              href="#orders"
              @click.prevent="setActive('orders')"
              @click="getOrdersReports()"
            >{{ $t('buttons.salesOrders') }}</a>
          </li>
        </ul>
        <div
          id="myTabContent"
          class="tab-content "
        >
          <div
            id="account"
            class="tab-pane fade row"
            :class="{ 'active show': isActive('account') }"
          >
            <div class="container-fluid">
              <div class="row">
                <div class="col-12 col-lg-6">
                  <div class="card text-black mb-3">
                    <div class="card-header">
                      {{ $t('customer.information') }}
                    </div>
                    <div class="card-body">
                      <div class="row inline">
                        <label
                          for="cardCode"
                          class="col-form-label col-12 col-sm-4 col-xl-3"
                        > {{ $t('customer.cardCode') }}</label>
                        <div class="card-text col-sm-8">
                          <input
                            id="cardCode"
                            type="text"
                            readonly
                            class="form-control-plaintext"
                            :value="currentCustomer.cardCode"
                          >
                        </div>
                      </div>
                      <div class="row inline">
                        <label
                          for="company"
                          class="col-form-label col-12 col-sm-4 col-xl-3"
                        >{{ $t('customer.company') }}</label>
                        <div class="card-text col-sm-8">
                          <input
                            id="company"
                            type="text"
                            readonly
                            class="form-control-plaintext"
                            :value="currentCustomer.company"
                          >
                        </div>
                      </div>
                      <div class="row inline">
                        <label
                          for="vat"
                          class="col-form-label col-12 col-sm-4 col-xl-3"
                        >{{ $t('customer.vatNumber') }}</label>
                        <div class="card-text col-sm-8">
                          <input
                            id="vat"
                            type="text"
                            disabled="disabled"
                            class="form-control-plaintext"
                            :value="currentCustomer.vat"
                          >
                        </div>
                      </div>
                      <div class="row inline">
                        <label
                          for="email"
                          class="col-form-label col-12 col-sm-4 col-xl-3"
                        > {{ $t('customer.email.index') }}</label>
                        <div class="card-text col-sm-8">
                          <input
                            id="email"
                            type="text"
                            readonly
                            class="form-control-plaintext"
                            :value="currentCustomer.email"
                          >
                        </div>
                      </div>
                      <div class="row inline">
                        <label
                          for="key"
                          class="col-form-label col-12 col-sm-4 col-xl-3"
                        >    {{ $t('customer.salesManger') }}</label>
                        <div class="card-text col-sm-8">
                          <input
                            id="key"
                            type="text"
                            readonly
                            class="form-control-plaintext"
                            :value="currentCustomer.salesRepresentative"
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6 ">
                  <div
                    class="card text-black mb-3"
                  >
                    <div class="card-header">
                      {{ $t('customer.billingAddress') }}
                    </div>
                    <div
                      v-if="currentCustomer && currentCustomer.billing"
                      class="card-body"
                    >
                      <div class="row inline">
                        <label
                          for="addressNameBilling"
                          class="col-form-label col-12 col-sm-4 col-xl-3"
                        > {{ $t('customer.addressName') }}</label>
                        <div class="card-text col-sm-8">
                          <input
                            id="addressNameBilling"
                            type="text"
                            readonly
                            class="form-control-plaintext"
                            placeholder="np. Oddział Warszawa - Bielany"
                            :value="currentCustomer.billing[0]['company']"
                          >
                        </div>
                      </div>
                      <div class="row inline">
                        <label
                          for="cityBilling"
                          class="col-form-label col-12 col-sm-4 col-xl-3"
                        > {{ $t('customer.city') }}</label>
                        <div class="card-text col-sm-8">
                          <input
                            id="cityBilling"
                            type="text"
                            readonly
                            class="form-control-plaintext"
                            :value="currentCustomer.billing[0]['city']"
                          >
                        </div>
                      </div>
                      <div class="row inline">
                        <label
                          for="streetBilling"
                          class="col-form-label col-12 col-sm-4 col-xl-3"
                        > {{ $t('customer.street') }}</label>
                        <div class="card-text col-sm-8">
                          <input
                            id="streetBilling"
                            type="text"
                            readonly
                            class="form-control-plaintext"
                            :value="currentCustomer.billing[0]['street']"
                          >
                        </div>
                      </div>
                      <div class="row inline">
                        <label
                          for="postCodeBilling"
                          class="col-form-label col-12 col-sm-4 col-xl-3"
                        > {{ $t('customer.postcode') }}</label>
                        <div class="card-text col-sm-8">
                          <input
                            id="postCodeBilling"
                            type="text"
                            readonly
                            class="form-control-plaintext"
                            :value="currentCustomer.billing[0]['postcode']"
                          >
                        </div>
                      </div>
                      <div class="row inline">
                        <label
                          for="countryBilling"
                          class="col-form-label col-12 col-sm-4 col-xl-3"
                        > {{ $t('customer.country') }}</label>
                        <div class="card-text col-sm-8">
                          <input
                            id="countryBilling"
                            type="text"
                            readonly
                            class="form-control-plaintext"
                            :value="currentCustomer.billing[0]['country']"
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-header">
                {{ $t('customer.customerPayment') }}
              </div>
              <div class="table-responsive">
                <table class=" table table-bordered table-striped p-2">
                  <thead>
                    <tr>
                      <th scope="col">
                        {{ $t('customer.balancePayment') }}
                      </th>
                      <th scope="col">
                        {{ $t('customer.creditLimit') }}
                      </th>
                      <th scope="col">
                        {{ $t('customer.overduePayments') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <!--                                    {{ getCustomerInfo()}}-->
                    <tr
                      v-for="cr in customerBalance"
                      :key="cr['docEntry']"
                      class="m-1 p-1 bg-light"
                    >
                      <td class="">
                        <h6>{{ currencyDisplay(cr['balance'], false, true) }} </h6>
                      </td>
                      <td class="">
                        <h6>{{ currencyDisplay(cr['creditLimit'], false, true) }}</h6>
                      </td>
                      <td><h6>{{ currencyDisplay(cr['overdue'], false, true) }}</h6></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-header">
                {{ $t('customer.lastOrders') }}
              </div>
              <div class="">
                <div class="table-responsive">
                  <table class="table table-bordered table-striped p-2">
                    <thead>
                      <tr>
                        <th scope="col">
                          {{ $t('customer.orderNumber') }}
                        </th>
                        <th scope="col">
                          {{ $t('customer.createdDate') }}
                        </th>
                        <th scope="col">
                          {{ $t('customer.shippingAddressName') }}
                        </th>
                        <th scope="col">
                          {{ $t('customer.summary') }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="co in currentCustomer.orders"
                        :key="co['orderId']"
                        class="m-1 p-1 bg-light"
                      >
                        <td class="">
                          <h6>{{ co['orderNumber'] }}</h6>
                        </td>
                        <td class="">
                          <h6>{{ co['createdAt'] }}</h6>
                        </td>
                        <td><h6>{{ co['company'] }}</h6></td>
                        <td>
                          <span
                            class="badge badge-pill badge-primary float-right"
                          >
                            <h6 class="m-0">    {{ currencyDisplay(co['grandTotal'], false, true) }}</h6>
                          </span>
                        </td>
<!--                        <td><h6>{{ co['status'] }}</h6></td>-->
                        <td
                          colspan="3"
                          class="text-center"
                        >
                          <button
                            class="btn btn-theme-info btn-sm text-center"
                            @click="showOrder(co)"
                          >
                            {{ $t('buttons.showOrder') }}
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div
            id="addresses"
            class="tab-pane fade"
            :class="{ 'active show': isActive('addresses') }"
          >
            <div class="container pl-0 pr-0">
              <div class="row">
                <div class="col-md-12">
                  <button
                    class="btn btn-theme-info btn-sm text-center float-right mb-2 mt-2"
                    @click="openAddNewForm()"
                  >
                    {{ $t('buttons.new') }}
                  </button>
                </div>
                <div class="col-md-12 col-12">
                  <div class="mb-2">
                    <multiselect
                      class="form-control-select textarea"
                      :placeholder="$t('buttons.selectAddress')"
                      :value="currentAddress"
                      :options="selectOptions"
                      track-by="id"
                      label="name"
                      :searchable="true"
                      deselect-label=""
                      select-label=""
                      @input="updateValueAction($event)"
                    />
                  </div>
                  <validation-observer
                    ref="v-observer"
                  >
                    <div class="container-fluid pl-0 pr-0">
                      <div class="row">
                        <div class="form-group col-md-12 ">
                          <label for="city">
                            {{ $t('customer.addressName') }}
                          </label>
                          <div class="form-group col-md-6 mb-2">
                            <validation-provider
                              v-slot="v"
                              slim
                              rules="required"
                              name="addressName"
                            >
                              <input
                                id="addressName"
                                v-model="currentAddress.addressName"
                                :placeholder="addNewMode ? $t('customer.addressName') : ''"
                                :disabled="!addNewMode"
                                type="text"
                                class="form-control "
                                :class="{
                                  'is-invalid': v.errors.length
                                }"
                              >
                              <div
                                v-if="v.errors[0]"
                                class="invalid-feedback"
                              >
                                {{ v.errors[0] }}
                              </div>
                            </validation-provider>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group col-md-3">
                            <label for="city">
                              {{ $t('customer.city') }}
                            </label>
                          </div>
                          <div class="form-group offset-md-1 col-md-11">
                            <validation-provider
                              v-slot="v"
                              slim
                              rules="required"
                            >
                              <input
                                id="city"
                                v-model="currentAddress.city"
                                :placeholder="addNewMode ? $t('customer.city') : ''"
                                :disabled="cityInputDisabled"
                                type="text"
                                class="form-control"
                                :class="{
                                  'is-invalid': v.errors.length
                                }"
                              >
                            </validation-provider>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group col-md-3  ">
                            <label for="street">
                              {{ $t('customer.street') }}
                            </label>
                          </div>
                          <div class="form-group offset-md-1 col-md-11 ">
                            <validation-provider
                              v-slot="v"
                              slim
                              rules="required"
                            >
                              <input
                                id="street"
                                v-model="currentAddress.street"
                                :placeholder="addNewMode ? $t('customer.street') : ''"
                                :disabled="streetInputDisabled"
                                type="text"
                                class="form-control "
                                :class="{
                                  'is-invalid': v.errors.length
                                }"
                              >
                            </validation-provider>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group col-md-3  ">
                            <label for="street">
                              {{ $t('customer.country') }}
                            </label>
                          </div>
                          <div class="form-group offset-md-1 col-md-11 ">
                            <validation-provider
                              v-slot="v"
                              slim
                              rules="required"
                            >
                              <select
                                id="countryId"
                                :value="currentAddress.country"
                                :placeholder="addNewMode ? $t('customer.country') : ''"
                                :disabled="streetInputDisabled"
                                type="text"
                                class="form-control "
                                :class="{
                                  'is-invalid': v.errors.length
                                }"
                                @input="currentAddress.country = $event.target.value"
                              >
                                <option
                                  v-for="country in countryList"
                                  :key="country.code"
                                  :value="country.code"
                                >
                                  {{ country.name }}
                                </option>
                              </select>
                            </validation-provider>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group  col-md-3 ">
                            <label for="postcode">
                              {{ $t('customer.postcode') }}
                            </label>
                          </div>
                          <div class="form-group offset-md-1 col-md-11">
                            <validation-provider
                              v-slot="v"
                              slim
                              rules="required"
                            >
                              <input
                                id="postCode"
                                v-model="currentAddress.postcode"
                                :placeholder="addNewMode ? $t('customer.postcode') : ''"
                                :disabled="postCodeInputDisabled"
                                type="text"
                                class="form-control "
                                :class="{
                                  'is-invalid': v.errors.length
                                }"
                              >
                            </validation-provider>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group  col-md-3 ">
                            <label for="personName">
                              {{ $t('customer.personName') }}
                            </label>
                          </div>
                          <div class="form-group offset-md-1 col-md-11">
                            <validation-provider
                              v-slot="v"
                              slim
                              rules="required"
                            >
                              <input
                                id="personName"
                                v-model="currentAddress.personName"
                                :placeholder="addNewMode ? $t('customer.personName') : ''"
                                :disabled="personNameDisabled"
                                type="text"
                                class="form-control "
                                :class="{
                                  'is-invalid': v.errors.length
                                }"
                              >
                            </validation-provider>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group  col-md-3 ">
                            <label for="personEmail">
                              {{ $t('customer.personEmail') }}
                            </label>
                          </div>
                          <div class="form-group offset-md-1 col-md-11">
                            <validation-provider
                              v-slot="v"
                              slim
                              rules="required"
                            >
                              <input
                                id="personEmail"
                                v-model="currentAddress.personEmail"
                                :placeholder="addNewMode ? $t('customer.personEmail') : ''"
                                :disabled="personEmailDisabled"
                                type="text"
                                class="form-control "
                                :class="{
                                  'is-invalid': v.errors.length
                                }"
                              >
                            </validation-provider>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group  col-md-3 ">
                            <label for="personPhone">
                              {{ $t('customer.personPhone') }}
                            </label>
                          </div>
                          <div class="form-group offset-md-1 col-md-11 ">
                            <validation-provider
                              v-slot="v"
                              slim
                              rules="required"
                            >
                              <input
                                id="personPhone"
                                v-model="currentAddress.personPhone"
                                :placeholder="addNewMode ? $t('customer.personPhone') : ''"
                                :disabled="personPhoneDisabled"
                                type="text"
                                class="form-control "
                                :class="{
                                  'is-invalid': v.errors.length
                                }"
                              >
                            </validation-provider>
                          </div>
                        </div>
                        <div class="form-inline float-right offset-8">
                          <button
                            class="btn btn-theme-info btn-sm text-center float-right"
                            @click="openAddressEditForm()"
                          >
                            {{ $t('buttons.edit') }}
                          </button>
                          <button
                            v-show="saveAddressForm"
                            class="btn btn-theme-add btn-sm ml-3 text-center float-right saveAddressForm"
                            @click="addNewMode ? saveAddressAddForm() : saveAddressEditForm()"
                          >
                            {{ $t('buttons.save') }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </validation-observer>
                </div>
              </div>
            </div>
          </div>
          <div
            id="invoices"
            class="tab-pane fade"
            :class="{ 'active show': isActive('invoices') }"
          >
            <div
              v-show="displayInvoicePdf"
              id="viewInvoice"
            >
              <button
                class="btn-dark"
                @click="hideInvoicePdf()"
              />
              <embed
                id="generatePdfInvoice"
                class="pdfInvoice"
                :src="invoiceSrc"
                width="100%"
                height="600px"
              >
            </div>

            <div class="col-md-12 pl-0 pr-0">
              <div class="table-responsive">
                <table
                  id="invoicesTable"
                  class="table table-striped table-bordered"
                  style="width:100%"
                >
                  <thead>
                    <tr>
                      <th>{{ $t('customer.documentNumber') }}</th>
                      <th>{{ $t('customer.docDate') }}</th>
                      <th>{{ $t('customer.dueDate') }}</th>
                      <th>{{ $t('customer.dayAfter') }}</th>
                      <th>{{ $t('customer.status') }}</th>
                      <th>{{ $t('customer.summary') }}</th>
                      <th>{{ $t('customer.tax') }}</th>
                      <th>{{ $t('customer.netValue') }}</th>
                      <th>PDF</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="i in invoiceReports"
                      :key="i['docEntry']"
                      class="m-1 p-1 bg-light"
                    >
                      <td>{{ i['docNum'] }}</td>
                      <td>{{ i['docDate'] }}</td>
                      <td>{{ i['docDueDate'] }}</td>
                      <td>{{ i['dayAfter'] }}</td>
                      <td> {{ i['status'] }}</td>
                      <td>{{ currencyDisplay(i['gross'], false, true) }}</td>
                      <td>{{ currencyDisplay(i['vat'], false, true) }} </td>
                      <td>{{ currencyDisplay(i['net'], false, true) }} </td>
                      <td>
                        <button
                          :value="i['docEntry']"
                          @click="getInvoicePdf(i)"
                        >
                          PDF
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div
            id="orders"
            class="tab-pane fade"
            :class="{ 'active show': isActive('orders') }"
          >
            <div
              v-show="displayOrderPdf"
              id="viewOrder"
            >
              <button
                width="100%"
                class="btn-dark"
                @click="hideOrderPdf()"
              />
              <embed
                id="generatePdfOrder"
                class="pdfInvoice"
                :src="orderSrc"
                width="100%"
                height="600px"
              >
            </div>
            <div class="col-md-12 pl-0 pr-0">
              <div class="table-responsive">
                <table
                  id="ordersTable"
                  class="table table-striped table-bordered"
                  style="width:100%"
                >
                  <thead>
                    <tr>
                      <th>{{ $t('customer.documentNumber') }}</th>
                      <th>{{ $t('basket.proposalDateTime') }}</th>
                      <th>{{ $t('basket.comment') }}</th>
                      <th>{{ $t('customer.status') }}</th>
                      <th>{{ $t('customer.summary') }}</th>
                      <th>{{ $t('customer.tax') }}</th>
                      <th>{{ $t('customer.netValue') }}</th>
                      <th>PDF</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="o in ordersReports"
                      :key="o['docEntry']"
                      class="m-1 p-1 bg-light"
                    >
                      <td>{{ o['docNum'] }}</td>
                      <td>{{ o['docDate'] }}</td>
                      <td>{{ o['message'] }}</td>
                      <td>{{ o['status'] }}</td>
                      <td>{{ currencyDisplay(o['gross'], false, true) }}</td>
                      <td>{{ currencyDisplay(o['vat'], false, true) }} </td>
                      <td>{{ currencyDisplay(o['net'], false, true) }} </td>
                      <td>
                        <button
                          :value="o['docEntry']"
                          @click="getOrderPdf(o)"
                        >
                          PDF
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <historic-order-modal
      :visible="isOrderModalVisible"
      :order="showedOrder"
      @on-close="isOrderModalVisible = !isOrderModalVisible"
      @on-confirm="reorderProduct($event)"
    />
  </div>
</template>
<script>
    import Vue from 'vue'
    import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
    import *  as ServiceReport from "../services/reports";
    import Multiselect from 'vue-multiselect'
    import { currencyMixin } from '../mixins';
    import { CountryList } from '../enums/CountriesAll';
    import HistoricOrderModal from './HistoricOrderModal';
    import i18n from "../translations";
    import { ValidationObserver, ValidationProvider } from 'vee-validate';

    export default {
        name: "CustomerDetails",
        components: { Multiselect, HistoricOrderModal, ValidationObserver, ValidationProvider },
        filters: {
          currency(value) {
            return new Intl.NumberFormat("pl-PL", {
              style: "currency",
              currency: "PLN"
            }).format(value);
          }
        },
        mixins: [currencyMixin],
        props: {
            id: {
                type: String,
                required: true
            }
        },
        data: function () {
            return {
                countryList: CountryList,
                activeItem: 'account',
                invoiceReports : [],
                ordersReports : [],
                customerBalance: [],
                allowOrder: true,
                breakOrder: false,
                displayOrderPdf: false,
                displayInvoicePdf: false,
                saveAddressForm: false,
                currentCustomer: [],
                currentBilling:  [],
                cardCode: '',
                console,
                currentAddress: [],
                cityInputDisabled: true,
                streetInputDisabled: true,
                postCodeInputDisabled: true,
                personNameDisabled:true,
                personEmailDisabled:true,
                personPhoneDisabled:true,
                addNewMode: false,
                invoiceSrc: "",
                orderSrc: "",
                showedOrder: null,
                isOrderModalVisible: false,
            };
        },
        computed: {
          ...mapState('customers', ['customer']),
          ...mapGetters('auth', ['user']),
          ...mapGetters('customers', ['shipping']),
          ...mapState('products', ['products']),
          ...mapGetters('customers', ['billing']),
          selectOptions() {
            return this.shipping ? this.shipping.map(shipObject => ({
              name:  shipObject.addressName+ " - "+ shipObject.city + " - " + shipObject.street,
              id: shipObject.addressId,
            })) : [];
          },
        },
        watch: {
          customer(newValue){
           this.currentCustomer = newValue;
          },
          billing(newValue){
           this.currentBilling = newValue;
          },

        },
        mounted () {
           this.cardCode = (this.user.cardCode) ? this.user.cardCode : null;
           this.getCustomerBalance();
           this.getCurrentCustomer();
          // this.getProductsToCardCode();
           this.setUserLangauge();
           // Vue.alert(`${ i18n.t('customer.infoMessage2')}`,`${ i18n.t('customer.info2')}`,"info");
        },
        methods: {
            ...mapMutations({ selectCustomer: "cart/selectOrderType" }),
            ...mapMutations('cart', ['setLanguage']),
            ...mapMutations('currency', ['setCurrency']),
            ...mapActions('cart', ['addProduct',]),
            ...mapActions('products', ['getProductsToCardCode']),
            ...mapActions('customers', ['updateCustomerShipping', 'addCustomerShipping', 'getCurrentCustomer']),
            updateValueAction (value) {
              const addressData = this.shipping.find(shipObject => shipObject.addressId === value.id);
              // We do a clone to avoid mutation outside vuex
              if (addressData) {
                this.currentAddress = {
                  ...addressData
                };
              }
            },
            setUserLangauge(){
              let language = this.user.localization.substring(0, 2);
              i18n.locale = language;
              this.setLanguage(language);
              if(language === "en")
                this.setCurrency("EUR");
            },
            nameShippingAddress ({ addressName, street}) {
              return `${addressName} — [${street}]`;
            },
            handleSelectCustomerAddress(shipping) {
              this.$store.commit("cart/selectCustomer", shipping);
              this.$store.commit("cart/setCartData",[]);
              localStorage.removeItem("cart");
            },
            handleSelectTypeOrder(customer) {
                this.selectOrderType(customer);
                this.$router.push("/order");
            },
            hideInvoicePdf(){
              this.displayInvoicePdf = false;
            },
            hideOrderPdf(){
                this.displayOrderPdf = false;
            },
            handleRedirectToCart(){
                this.$router.push('/cart')
            },
            isActive (menuItem) {
                return this.activeItem === menuItem
            },
            setActive (menuItem) {
                this.activeItem = menuItem
            },
          async getInvoicePdf(invoice){
            let response = await ServiceReport.getInvoicePdf(invoice);
            if (response.data) {
              var base64 =  response.data.reportFormSubmit.allReports;
              //  this.invoiceSrc = "data:application/pdf;base64," +base64[0].message;
              // document.getElementById('generatePdfInvoice')
              //     .setAttribute(
              //         'src', "data:application/pdf;base64,"+base64[0].message
              //     );
              var currentEmbed = document.getElementById('generatePdfInvoice');
              currentEmbed.remove();
              var embed = document.createElement('embed');
              embed.setAttribute('width', '100%');
              embed.setAttribute('height', '600px');
              embed.setAttribute('id', 'generatePdfInvoice');
              embed.setAttribute('src', "data:application/pdf;base64," +base64[0].message);
              document.getElementById('viewInvoice').appendChild(embed);

              let pdfWindow = window.open("");
              pdfWindow.document.write(
                      "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
                      encodeURI(base64[0].message) + "'></iframe>"
              );
             // this.displayInvoicePdf = true;
            } else {
              console.log(response)
            }
          },
          async getOrderPdf(order){
            let response = await ServiceReport.getOrderPdf(order);
            if (response.data) {
              var base64 =  response.data.reportFormSubmit.allReports;
              // document.getElementById('generatePdfOrder')
              //     .setAttribute(
              //         'src', "data:application/pdf;base64,"+base64[0].message
              //     );
              var currentEmbed = document.getElementById('generatePdfOrder');
              currentEmbed.remove();
              var embed = document.createElement('embed');
              embed.setAttribute('width', '100%');
              embed.setAttribute('height', '600px');
              embed.setAttribute('id', 'generatePdfOrder');
              embed.setAttribute('src', "data:application/pdf;base64," +base64[0].message);
              document.getElementById('viewOrder').appendChild(embed);
           //   window.open("data:application/pdf;base64," + encodeURI(base64[0].message));
              let pdfWindow = window.open("");
              pdfWindow.document.write(
                      "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
                      encodeURI(base64[0].message) + "'></iframe>"
              );
              // var windowReference = window.open();
              //
              // response.then(function(url) {
              //   windowReference.location = url;
              //   windowReference.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
              //           encodeURI(base64[0].message) + "'></iframe>")
              // });
            //  this.displayOrderPdf = true;
            } else {
              console.log(response)
            }
          },
            async getInvoiceReport(){
                let response = await ServiceReport.getInvoicesByCustomer(this.cardCode);
                if (response.data) {
                    this.invoiceReports =  response.data.reportFormSubmit.allReports;
                } else {
                    console.log(response)
                }
            },
            async getOrdersReports(){
                let response = await ServiceReport.getOrdersByCustomer(this.cardCode);
                if (response.data) {
                    this.ordersReports =  response.data.reportFormSubmit.allReports;
                } else {
                    console.log(response)
                }
            },
            async getCustomerBalance(){
               let response = await ServiceReport.getBalanceByCustomer(this.cardCode);
                if (response.data) {
                  this.customerBalance = response.data.reportFormSubmit.allReports;
                  console.log(response.data.reportFormSubmit.allReports);
                  let balance = parseInt(this.customerBalance[0].overdue);
                  this.allowOrder = (balance > 0) ? false: true ;
                  console.log(this.allowOrder);
                  console.log(this.customerBalance);
                } else {
                    console.log(response)
                }
                return [];
            },
            openAddressEditForm(){
                this.addNewMode = false;
                this.saveAddressForm = true;
                this.streetInputDisabled = false;
                this.postCodeInputDisabled = false;
                this.cityInputDisabled = false;
                this.personNameDisabled = false;
                this.personEmailDisabled = false;
                this.personPhoneDisabled = false;
            },
            openAddNewForm(){
                this.addNewMode = true;
                this.saveAddressForm = true;
                this.streetInputDisabled = false;
                this.postCodeInputDisabled = false;
                this.cityInputDisabled = false;
                this.personNameDisabled = false;
                this.personEmailDisabled = false;
                this.personPhoneDisabled = false;
                this.currentAddress = {};
                this.$set(this.currentAddress, 'city', '');
                this.$set(this.currentAddress, 'street', '');
                this.$set(this.currentAddress, 'postcode', '');
                this.$set(this.currentAddress, 'addressName', '');
                this.$set(this.currentAddress, 'personName', '');
                this.$set(this.currentAddress, 'personEmail', '');
                this.$set(this.currentAddress, 'personPhone', '');
            },
            async saveAddressEditForm(){
              this.$refs['v-observer'].validate().then(async result => {
                if (result) {
                  // if (this.shipping) {
                  //   let sameNameShipping = this.shipping.find(shipping => shipping.addressName === this.currentAddress.addressName);
                  //   if (sameNameShipping) {
                  //     this.$refs['v-observer'].setErrors({
                  //       addressName: [this.$t('customer.errors.shippingAddressName')]
                  //     });
                  //     return;
                  //   }
                  // }
                  await this.updateCustomerShipping(this.currentAddress);
                  this.addNewMode = false;
                  this.saveAddressForm = false;
                  this.streetInputDisabled = false;
                  this.postCodeInputDisabled = false;
                  this.cityInputDisabled = false;
                  this.personNameDisabled = false;
                  this.personEmailDisabled = false;
                  this.personPhoneDisabled = false;
                }
              });
            },
            async saveAddressAddForm(){
              this.$refs['v-observer'].validate().then(async result => {
                if (result) {
                  if (this.shipping) {
                    let sameNameShipping = this.shipping.find(shipping => shipping.addressName === this.currentAddress.addressName);
                    if (sameNameShipping) {
                      this.$refs['v-observer'].setErrors({
                        addressName: [this.$t('customer.errors.shippingAddressName')]
                      });
                      return;
                    }
                  }
                  await this.addCustomerShipping(this.currentAddress);
                  this.currentAddress = {
                    ...this.shipping[this.shipping.length - 1]
                  }
                  this.openAddressEditForm();
                }
              });
            },
            showOrder (co) {
              this.showedOrder = co;
              this.isOrderModalVisible = true;
            },
            reorderProduct (historicProduct) {
              let orderedProduct = this.products.find(product => product.id === historicProduct.id)
              if (orderedProduct) {
                this.addProduct({
                  ...orderedProduct,
                  price: parseFloat(historicProduct.price),
                  quantity: parseFloat(historicProduct.quantity),
                });
              } else {
                Vue.alert('Produkt jest już niedostępny.')
              }
            }
        },
    };
</script>
<style scoped>
    .card-text > label {
        min-width:100px;
    }
    .form-inline{
        border: solid 1px #ebebe4;
        padding: 5px;
    }
</style>
